import { Checkbox, Header, Icon, Segment } from "semantic-ui-react";

import React, { useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import useCountryOptions from "astrid-hooks/src/useCountryOptions";

import Flex from "../../../../components/Flex/Flex";

import Form from "../../../forms/components/Form/Form";

export default function DistributionCountriesCheckboxTable({ name }) {
	const { t } = useTranslation();
	const contentRef = useRef(null);

	const { watch, setValue, formState } = useFormContext();

	const value = watch(name);

	const countryOptions = useCountryOptions();

	const [isExpanded, setIsExpanded] = useState(false);
	const [showTable, setShowTable] = useState(!!value?.length);

	const toggleExpand = () => {
		setIsExpanded((prev) => !prev);
	};

	const toggleWorld = () => {
		setShowTable((showTable) => {
			if (showTable) {
				setValue(name, [], { shouldDirty: true });
			}

			return !showTable;
		});
	};

	return (
		<Segment>
			<Header
				as="h4"
				style={{
					display: "flex",
					alignItems: "center",
					marginBottom: isExpanded ? 5 : 0,
					cursor: "pointer",
				}}
				onClick={toggleExpand}
			>
				{t("countries", "Countries")}
				<Flex justifyContent="flex-end">
					<Icon link name={isExpanded ? "angle up" : " angle down"} fitted />
				</Flex>
			</Header>

			{isExpanded && (
				<>
					<Checkbox
						slider
						onChange={toggleWorld}
						checked={showTable}
						disabled={formState.disabled}
						label={showTable ? t("selectCountries", "Select countries") : t("world", "World")}
						style={{ marginBottom: showTable ? 10 : 0 }}
					/>

					{showTable && (
						<div
							style={{
								overflow: "scroll",
								transform: isExpanded ? "scaleY(1)" : "scaleY(0)",
								transformOrigin: "top",
								maxHeight: isExpanded ? 400 : 0,
								opacity: isExpanded ? 1 : 0,
								transition: "transform 0.3s ease, opacity 0.3s ease, max-height 0.3s ease",
								willChange: "transform, opacity, max-height",
							}}
						>
							<div ref={contentRef}>
								<Form.FormCheckboxTable
									name={name}
									value={
										value?.[0] === "WORLD" || !value?.length
											? countryOptions.map(({ value }) => value)
											: value
									}
									options={countryOptions}
									transformValue={(value) => {
										return value.length === countryOptions.length ? [] : value;
									}}
									shouldUnregister={false}
								/>
							</div>
						</div>
					)}
				</>
			)}
		</Segment>
	);
}
